(ns dashboard.components.confirm-delete-file-modal
  (:require [dashboard.components.confirm-modal :refer [confirm-modal]]))

(defn modal-content [{:keys [filename custom-name]}]
  [:p "You are about to delete: "
   [:strong (or filename custom-name)]])

(defn confirm-delete-file-modal [{:keys [on-confirm]}]
  (partial #'confirm-modal
           {:title                 "Confirm Delete File"
            :content               #'modal-content
            :label-confirm         "Confirm Delete"
            :invert-button-colors? true
            :notification-classes  ["has-background-danger" "has-text-white" "is-shadowless"]
            :disable-confirm       (fn [{:keys [id]}]
                                     (nil? id))
            :on-confirm            on-confirm}))
